import { createAction, props } from '@ngrx/store';
import { NextStep } from '@shared/models/next-step';
import { NextStepFilters } from '@shared/models/next-step-filters';
import { PaginationState } from '@shared/models/pagination-state';
import { Sorting } from '@shared/models/sorting';

export const loadNextSteps = createAction(
  '[Next Steps] Load Next Steps',
  props<{ filters: NextStepFilters; paginationState: PaginationState; sorting: Sorting }>(),
);

export const loadNextStepsSuccess = createAction(
  '[Next Steps] Load Next Steps Success',
  props<{ nextSteps: NextStep[]; paginationState?: PaginationState }>(),
);

export const loadNextStepsFailure = createAction('[Next Steps] Load Next Steps Failure', props<{ error: any }>());
